import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilter = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 100 100",
	style: { enableBackground: "new 0 0 100 100" },
	xmlSpace: "preserve",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			className: "icon-white",
			d: "M26,27.1c0,0,7.1-2.6,13.7-1.7c3.1,0.4,7.3,1.2,10.3,2.7c3.6,1.8,7,2.3,10.6,2.3 c6.9,0,13.3-2.4,13.3-2.4l-15,29.6l-0.2,21.1L41.9,87l-1.2-30.3L26,27.1z"
		}),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M61.6,31.5h-0.1c-1.5,0-2.7,0-3.7-0.1c-0.7-0.1-1.3-0.7-1.2-1.4c0.1-0.7,0.7-1.3,1.4-1.2 c1,0.1,2.1,0.1,3.5,0.1h0.1c0.5,0,1.1,0,1.6,0c0.8,0,1.4,0.5,1.4,1.3c0,0.7-0.5,1.4-1.3,1.4C62.8,31.5,62.2,31.5,61.6,31.5z  M68.6,30.8c-0.6,0-1.2-0.4-1.3-1.1c-0.2-0.7,0.3-1.4,1-1.6c1.8-0.4,3.4-0.9,4.8-1.6c0.7-0.3,1.5,0,1.8,0.6c0.3,0.7,0,1.5-0.6,1.8 c-1.6,0.8-3.4,1.4-5.4,1.8C68.8,30.8,68.7,30.8,68.6,30.8z M52.6,30.3c-0.1,0-0.3,0-0.4-0.1c-1-0.3-2-0.7-3.3-1.2L48.7,29 c-0.6-0.2-1.1-0.4-1.6-0.6c-0.7-0.3-1.1-1-0.8-1.7c0.3-0.7,1-1.1,1.7-0.8c0.5,0.2,1,0.4,1.6,0.6l0.2,0.1c1.3,0.5,2.3,0.8,3.2,1.1 c0.7,0.2,1.1,1,0.9,1.7C53.7,30,53.2,30.3,52.6,30.3z M26.4,28.4c-0.5,0-1.1-0.3-1.3-0.9c-0.3-0.7,0.1-1.5,0.8-1.7 c1.6-0.6,3.5-1.1,5.5-1.4c0.7-0.1,1.4,0.4,1.5,1.1c0.1,0.7-0.4,1.4-1.1,1.5c-1.8,0.3-3.5,0.7-4.9,1.2 C26.7,28.4,26.5,28.4,26.4,28.4z M42.4,27.1c-0.1,0-0.1,0-0.2,0c-1.3-0.2-2.9-0.3-5.1-0.3c-0.7,0-1.4-0.6-1.4-1.4 c0-0.7,0.6-1.3,1.3-1.3c2.4,0,4.1,0.1,5.6,0.3c0.7,0.1,1.2,0.8,1.1,1.5C43.6,26.6,43,27.1,42.4,27.1z"
		}) }),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-outline",
			d: "M57.2,56.4c-0.1,0.2-0.2,0.5-0.2,0.7v20.8l-14.1,7V57.2c0-0.3-0.1-0.5-0.2-0.7L20.2,14.1h59.5 L57.2,56.4z M82.4,11c0,0,0,0-32.4,0H17.9c-1.4,0-1.6,0.9-1.7,1.3c-0.1,0.3,0,0.7,0.2,1l23.6,44.3v29.9c0,0.5,0.3,1,0.7,1.3 c0.2,0.2,0.5,0.2,0.8,0.2c0.2,0,0.5-0.1,0.7-0.2l17.1-8.6c0.5-0.3,0.9-0.8,0.9-1.4V57.6l23.6-44.3c0.3-0.5,0.2-1,0-1.5 C83.4,11.3,82.9,11,82.4,11L82.4,11z"
		})
	] })
});
export default SvgFilter;
